<template>
    <div>
        <lookbook-write-link v-for="writeLayout in writeLayouts" :key="`lookbook${writeLayout}`"
                             :channelData="channelData"
                             :writeLayout="writeLayout" :lookbookData="lookbookData"></lookbook-write-link>
    </div>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import ApiFileUpload from "@/mixins/ApiFileUpload";
import lookbookUtil from "@/components/lookbook/lookbookUtil";
import LookbookWriteLink from "@/components/lookbook/LookbookWriteLink";
import lookbookValidator from "@/mixins/validators/LookbookValidator";

export default {
    name: "LookbookWriteComponent",
    mixins: [alertMixins, ApiFileUpload, lookbookUtil, lookbookValidator],
    components: {LookbookWriteLink},
    provide() {
        return {
            lookbookWriteSetData: this.setData,
        }
    },
    props: {
        lookbookType: {default: ''},
        lookbookKey: {default: 0},
    },
    data() {
        return {
            getFunc: '',
            detailApiParamSet: {},
            getChannelFunc: '',
            isChannel: false,
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            parsingData: {},
            fileInfo: [],
            directUrl: '',
            directType: '',
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            fileUploadFailMsg: '',
            deleteFunc: '',
            deleteApiParamsSet: {},
            deleteSuccessType: 1,
            deleteFailTypes: {},
            deleteKeyName: '',
            DeleteClass: null,
            isRunning: false,
            lookbookData: {},
            channelData: [],

        }
    },
    created() {
        this.initFilterConfig();
        if (this.lookbookKey === 0) {
            this.initTemplateConfig();
        } else {
            this.getLookbook();
        }
    },
    mounted() {
        EventBus.$on('writeLookbook', this.writeLookbook)
        EventBus.$on('writeDeleteLookbook', this.runDelete)
    },
    beforeDestroy() {
        EventBus.$off('writeLookbook')
        EventBus.$off('writeDeleteLookbook')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig() {
            let config = this.returnLookbookConfig(this.lookbookType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig() {
            let config = this.returnLookbookConfig(this.lookbookType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.getChannelFunc = config.getChannelFunc;
            this.isChannel = config.isChannel;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.parsingData = config.parsingData;
            this.allSetData = config.allSetData;
            this.fileInfo = config.fileInfo;
            this.directUrl = config.directUrl;
            this.directType = config.directType;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;
            this.deleteFunc = config.deleteFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.deleteSuccessType = config.deleteSuccessType;
            this.deleteFailTypes = config.deleteFailTypes;
            this.keyName = config.keyName;

            if (this.isChannel) {
                this.getChannel();
            }
            this.newDeleteClass();
        },
        getChannel() {
            let params = {
                ip: 0
            };
            try {
                this.$api.$lookbook[this.getChannelFunc](params).then(res => res.Data.Result).then(res => {
                    if (!util.isEmpty(res.List)) {
                        this.channelData = res.List;
                    }
                })
            } catch (e) {
                console.log(e);
            }
        },
        getLookbook() {
            let params = Object.assign({}, this.detailApiParamSet);
            params.id = this.lookbookKey;
            try {
                this.$api.$lookbook[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if (res.Info.Type != 1 || util.isEmpty(res.List)) {
                        this.errorAlert({
                            content: '상세를 가져올 수가 없습니다.',
                        })
                        this.$router.back();
                        return false;
                    }
                    this.lookbookData = res.List[0];
                    this.initTemplateConfig();
                })
            } catch (e) {
                console.log(e)
            }
        },
        newDeleteClass() {
            if (!util.isEmpty(this.deleteFunc)) {
                let deleteOptions = {
                    func: this.$api.$lookbook[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    keyName: this.keyName,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteFailTypes,
                    afterFunc: this.deleteAfterFunc,
                }
                this.DeleteClass = new DeleteClass(deleteOptions);
            }
        },

        runDelete(key, value) {
            EventBus.$emit('changeLoading', true);
            this.DeleteClass.runDelete(key, {mb_password: value,})
        },
        deleteAfterFunc() {
            EventBus.$emit('changeLoading', false)
            this.createAlert({
                content: '삭제가 완료되었습니다.',
                hide: () => {
                    this.$router.back();
                }
            })
        },
        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);
            if(!util.isEmpty(this.channelUrl)){
                validatorArr.push('channelUrl')
            }
            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                util.Array.each(this.fileInfo, (fileInfo, index, arr) => {
                    if (success && fileInfo.required && util.isEmpty(this[fileInfo.fileName])) {
                        this.errorAlert(fileInfo.validatorMsg)
                        success = false;
                    }
                })
                return success;
            })

        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(paramKey !== ''){
                    params[paramKey] = this[dataKey]
                } 
                if(this[dataKey] == this.lookbookData[paramKey]){
                    delete params[paramKey]
                }                
            })

            if (this.lookbookKey != 0) {
                params[this.keyName] = this.lookbookKey;
            }
            if (this.lookbookType === 'createLookbook' || this.lookbookType === 'updateLookbook') {
                params = this.makeHash(params);
            }

            return params
        },
        makeHash(params) {
            if (!util.isEmpty(this.hashtag)) {
                params.hash = []
                util.Array.each(this.hashtag, (data, index, arr) => {
                    params.hash.push({lh_idx: data});
                })
            } else if (this.lookbookType === 'updateLookbook' && this.lookbookData.Hash.length > 0) {
                params.hash = 'delete';
            }
            return params
        },


        async writeLookbook() {
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;
            let validator = await this._checkValidator()
            if (!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();
            if (params === false) {
                return false
            }
            try {
                this.$api.$lookbook[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        let key = '';
                        if (res.hasOwnProperty('List') && res.List.hasOwnProperty(this.keyName)) {
                            key = res.List[this.keyName];
                        }

                        if (this.lookbookKey != 0) {
                            key = this.lookbookKey;
                        }

                        this.runApiUploadFiles(this.fileInfo, key).then(res => {
                            this.afterFunc(key);
                        })

                    } else {
                        this.errorAlert(type);
                        this.isRunning = false;
                        EventBus.$emit('changeLoading', false);
                    }
                })
            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type == this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type]
            }
        },
        afterFunc() {
            this.isRunning = false;
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    if (this.directType === 'back') {
                        this.$router.back();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    if (this.directUrl === '') {
                        this.writeLayouts = [];
                        this.getLookbook();
                        EventBus.$emit('changeLoading', false)
                        return false;
                    }
                    EventBus.$emit('changeLoading', false)
                    let url = this.directUrl;
                    this.$router.push(url);
                }
            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
